import { IonButton, IonIcon, IonModal } from '@ionic/react';
import { close } from 'ionicons/icons';
import React from 'react';
import './WelcomeModal.css';
import iconXeguei from "./imgs/xegueiIcon.svg";

type WelcomeModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onStart: () => void;
};

const WelcomeModal: React.FC<WelcomeModalProps> = ({ isOpen, onClose, onStart }) => {
    return (
        <IonModal isOpen={isOpen} onDidDismiss={onClose}>
            <div className="welcome-modal-content">
                <IonButton fill="clear" className="welcome-modal-close" onClick={onClose}>
                    <IonIcon icon={close} />
                </IonButton>

                <img
                    src="/assets/logo-xeguei-laranja.png"
                    alt="Xeguei"
                    className="welcome-modal-logo"
                    onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
                />

                <div className="welcome-modal-mascot"> <IonIcon icon={iconXeguei} /></div>

                <div className="welcome-modal-title">
                    Bem-vindo ao Xeguei!
                </div>

                <div className="welcome-modal-subtitle">
                    Vamos configurar sua loja para começar a receber pedidos.
                </div>

                <IonButton expand="block" className="welcome-modal-btn" onClick={onStart}>
                    Configurar minha loja
                </IonButton>
            </div>
        </IonModal>
    );
};

export default WelcomeModal;
